// src/utils/nokkuNaal.js
import React from 'react';

export const nokkuNaal = (input) => {
    console.log("nokkuNaal", input);
    switch (input) {
        case "1":
            return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <img src="/icon/melnokku.png" alt="மேல் நோக்கு நாள்" width={30} height={30} />
                    <span>மேல் நோக்கு நாள்</span>
                </div>
            );
        case "2":
            return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <img src="/icon/keelnokku.png" alt="கீழ் நோக்கு நாள்" width={30} height={30} />
                    <span>கீழ் நோக்கு நாள்</span>
                </div>
            );
        case "3":
            return (
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <img src="/icon/samanokku.png" alt="சம நோக்கு நாள்" width={30} height={30} />
                    <span>சம நோக்கு நாள்</span>
                </div>
            );
        default:
            return null;
    }
};
